/* eslint jsx-a11y/href-no-hash: "off" */
import React from "react";
import { connect } from "react-redux";
import UnlocksList from "./UnlocksList";
import UserCrewRecord from "../battle/UserCrewRecord.js";
import MenuHeader from "../b5-home/MenuHeader.js";
import Switcher from "./Switcher";

class RecordsScreen extends React.Component {
  constructor() {
    super();
    this.state = {
      viewingScreen: "unlocks" //"unlocks" | "history"
    };
  }

  // handleGoBackHomeLink(e) {
  //   e.preventDefault();
  //   goToHomeScreen();
  // }

  handleNewSelectionChosen(newSelection) {
    this.setState({
      viewingScreen: newSelection
    });
  }

  //Maybe return styles that wrap the desktop layout together
  getDesktopWrap() {
    if (this.props.viewportMode === "portrait") {
      return {};
    }


    return {
      width: this.state.viewingScreen === "unlocks" ? "90em" : "40em", //wider wrap on Desktop/unlocks
      margin: "0 auto"
    };
  }

  renderRecord() {
    const crewTitleStyle = {
      container: {
        textAlign: "center",
        marginBottom: "4em"
      },
      label: {
        fontSize: "0.7em",
        marginBottom: "1em",
        color: "#877F8E"
      }
    };
    return (
      <div>
        <div style={crewTitleStyle.container}>
          <div style={crewTitleStyle.label}>Crew History</div>
          <div>
            {this.props.crewName}
          </div>
        </div>
        <UserCrewRecord />
      </div>
    );
  }

  renderUnlocks() {
    return <UnlocksList viewportMode={this.props.viewportMode} />;
  }

  render() {
    const style = {
      fontSize: this.props.viewportMode === "portrait" ? "0.6em" : "0.5em", //mobile, desktop
      height: "100%",
      paddingTop: "4em" //Same height as absolute header. Faking a box stacking behavior
    };

    return (
      <div style={{ height: "100%" }}>
        <div style={style} className="menu-texture">
          {/*Top, header container*/}
          <div>
            <MenuHeader />
          </div>

          <div style={{ padding: "1em", ...this.getDesktopWrap() }}>
            <Switcher
              options={["history", "unlocks"]}
              currentlyActiveKey={this.state.viewingScreen}
              handleNewSelection={this.handleNewSelectionChosen.bind(this)}
            />
            {this.state.viewingScreen === "unlocks"
              ? this.renderUnlocks()
              : this.renderRecord()}
          </div>
        </div>
      </div>
    );
  }
}

export default connect((state, props) => {
  return {
    crewName: state.crew.name,
    viewportMode: state.global.viewportMode
  };
})(RecordsScreen);



// WEBPACK FOOTER //
// ./src/b5-unlocks/RecordsScreen.js